import { Component } from 'react';
import {Switch, withRouter} from 'react-router-dom';
import axiosInstance from '../../axiosInstance';
import '../../css/main.css'
import logo from '../../logom.svg'
import menu from '../../menu.svg'
import Menu from '../components/Menu';
import PrivateRoute from '../components/PrivateRoute';
import { logOut } from '../helper';
import Dashboard from './Dashboard';
import Profile from './users/Profile'
import NewTicket from './ticket/NewTicket'
import ChildTicket from './ticket/ChildTicket';
import Users from './users/Users';
import NewUser from './users/NewUser';
import Roles from './role/Roles';
import TicketLogs from './ticket/TicketLogs';
import NewRole from './role/NewRole';
import NewType from './type/NewType';
import Types from './type/Types';
import Stages from './stage/Stages';
import NewStage from './stage/NewStage';
import Problems from './problem/Problems';
import NewProblem from './problem/NewProblem';
import NewContractDocument from './contracts/NewContractDocument';
import RemoveContractDocument from './contracts/RemoveContractDocument';
import ReplaceContractDocument from './contracts/ReplaceContractDocument';
import NoMatch from './NoMatch';
import DashboardSettings from './dashboard_settings/dashboard_settings';
import NewDashboardSetting from './dashboard_settings/new_dashboard_setting';
import UpdateTicket from './ticket/UpdateTicket';



class Main extends Component{

    constructor(props){
        super(props);
        this.state = {
            user:null,
            selected_menu_item : 1,
            role_permissions:[],
            location:"/dashboard"
        }        
    }

    componentDidMount(){
        window.addEventListener('resize',function(){
            let width = document.documentElement.clientWidth
            let nav = document.getElementById('side-navbar')
            if(nav){
                if(width > 780){
                    nav.style.display = 'flex'
                }else{
                    nav.style.display = 'none'
                }
            }
        })
        this.props.history.listen((location) =>{
            this.setState({
               location:location.pathname
            })
        })
        this.fetch_permissions();
        this.fetch_user_info();
    }   

    fetch_user_info(){
        axiosInstance.get('/users/auth')
        .then(response=>{
            this.setState({
               user:response.data.data
            })
        })
        .catch(err => {
            if(err?.response.status === 401){
                logOut(this.props);
            }
        });
    }
    show_hide_navigation(){
        let nav = document.getElementById('side-navbar')
        if(nav.style.display === 'flex'){
           nav.style.display = 'none'
        }else{
            nav.style.display = 'flex'
        }
    }
    logout(){
        logOut(this.props);
    }

    on_fetch_data(data){
        this.setState({
            role_permissions:data
        })
    }

    fetch_permissions(){
        axiosInstance.get('/roles/permissions/auth')
        .then(response=>{
            this.setState({
                role_permissions:response.data.data
            })
        })
        .catch(err => {
            if(err.response?.status === 401){
                logOut(this.props);
            }
        });
    }

    render(){
        return (
            <div className = "container-fluid">
                <div className = "header">
                    <button id = "navigation-btn" onClick = {this.show_hide_navigation}><img id="menu-icon" src ={menu} alt = "menu"></img></button> 
                    <img src = {logo} alt = "logo" id = 'logo' onClick = {(e) => {
                        this.props.history.push('/dashboard')
                    }} ></img>
                    <div className = "header-infobar">
                        <label id = "username-label">{this.state.user?.username}</label>
                        <button type="button" className="btn btn-light btn-sm" id="logout-btn" onClick = {(e)=>this.logout()}>გასვლა</button>
                    </div>
                </div>
                <div className = "main">
                    <div className = "navigation" id = "side-navbar">
                        <Menu permissions = {this.state.role_permissions} user = {this.state.user} location = {this.state.location}/>
                        <button id = "logout-btn-nav" onClick = {(e)=>this.logout()}>Log out</button>
                    </div>
                    <div className = "content">
                        <Switch>
                            <PrivateRoute exact path = {['/','/dashboard']}>
                                <Dashboard role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute path = "/profile/:id">
                                <Profile role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute exact path = '/dashboard/new_ticket'>
                                <NewTicket role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute exact path = '/dashboard/new_ticket/:id'>
                                <ChildTicket role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute exact path = '/dashboard/update_ticket/:id'>
                                <UpdateTicket role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/users'>
                                <Users role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/users/new_user'>
                                <NewUser role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/users/update_user/:id'>
                                <NewUser role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/roles'>
                                <Roles role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/ticket/logs/:id'>
                                <TicketLogs role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/roles/new_role'>
                                <NewRole role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/roles/update_role/:id'>
                                <NewRole role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/types'>
                                <Types role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/types/new_type'>
                                <NewType role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/types/update_type/:id'>
                                <NewType role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/stages'>
                                <Stages role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/stages/new_stage'>
                                <NewStage role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute> 
                            <PrivateRoute  exact path = '/problems'>
                                <Problems role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/problems/new_problem'>
                                <NewProblem role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/dashboard_settings'>
                                <DashboardSettings role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/dashboard_settings/new'>
                                <NewDashboardSetting role_permissions = {this.state.role_permissions}/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/pdf/new/:id/:firstname/:lastname/:personal_number'>
                                <NewContractDocument/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/pdf/remove/:id/:firstname/:lastname/:personal_number'>
                                <RemoveContractDocument/>
                            </PrivateRoute>
                            <PrivateRoute  exact path = '/pdf/replace/:id/:firstname/:lastname/:personal_number'>
                                <ReplaceContractDocument/>
                            </PrivateRoute>
                            <PrivateRoute >
                                <NoMatch/>
                            </PrivateRoute>
                        </Switch>
                    </div> 
                </div>
            </div>
        )
    }
}

export default withRouter(Main)